import { Banknote, CreditCard, Building2, HandCoins } from "lucide-react";

// Hızlı Satış (POS) ortak sabitleri — sayfa ve pos/* bileşenleri aynı kaynağı kullanır
export const KDV_DEFAULT = 20;
export const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const PAY_OPTIONS = [
  ["nakit", "Nakit", Banknote],
  ["kredi_karti", "Kredi Kartı", CreditCard],
  ["havale", "Havale / EFT", Building2],
  ["veresiye", "Veresiye", HandCoins],   // ödeme alınmadı → yalnız cari seçiliyken (borç cari deftere yazılır)
];
export const PAY_LABEL = { nakit: "Nakit", kredi_karti: "Kredi Kartı", havale: "Havale/EFT", veresiye: "Veresiye", karma: "Karma" };
// Parçalı ödeme özeti: "Nakit 200,00 ₺ · Kredi Kartı 300,00 ₺"
export const paymentsSummary = (parts) => (parts || []).map((p) => `${PAY_LABEL[p.method] || p.method} ${new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(p.amount) || 0)} ₺`).join(" · ");
// Fişin veresiye (açık) kısmı: karma fişte veresiye parçası, tam veresiyede fiş tutarı; tahsil edilen düşülür
export const isVeresiyeSale = (s) => !!s && (s.payment_method === "veresiye" || Number(s.veresiye_amount) > 0);
export const veresiyeRemaining = (s) => {
  if (!s) return 0;
  const grand = r2((Number(s.grand_total) || 0) - (Number(s.returned_total) || 0));
  const va = Number(s.veresiye_amount) || 0;
  const base = va > 0 ? Math.min(va, grand) : (s.payment_method === "veresiye" ? grand : 0);
  return r2(base - (Number(s.collected_total) || 0));
};
export const COST_SRC = { manual: "Manuel", invoice: "Faturadan", auto: "İskonto" };

// 3 satış fiyat modu (backend product_lookup `pos` ile hizalı)
export const MODES = [
  ["genel", "Genel Satış", "Perakende · KDV dahil"],
  ["faturali", "Elektrikçi Faturalı", "İskontolu · KDV dahil"],
  ["kdvsiz", "Elektrikçi KDV'siz", "Net · KDV yok"],
];
export const MODE_LABEL = { genel: "Genel Satış", faturali: "Elektrikçi Faturalı", kdvsiz: "Elektrikçi KDV'siz" };
